<template>
  <div class="app">
    <AppHeader />
    <div class="app-body">
      <Sidebar :navItems="navData" />
      <main class="main">
        <breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside />
    </div>
    <AppFooter />
  </div>
</template>

<script>
  import nav from '../_nav'
  import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb } from '../components/'
  import axios from 'axios'

  export default {
    name: 'full',
    components: {
      AppHeader,
      Sidebar,
      AppAside,
      AppFooter,
      Breadcrumb
    },
    async created() {
      try {
        let response = await axios.get('/api/internal/getexternalapplinks')
        this.navData.splice(0)
        this.navData.push(...nav.GetItems(response.data))
      } catch (error) {
        console.log(error)
        this.errMsg = 'Error getting external app links.'
      }
    },
    data() {
      return {
        navData: []
      }
    },
    computed: {
      name() {
        return this.$route.name
      },
      list() {
        return this.$route.matched
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/containers/Full.vue